// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hbfilms-top-header {
    position: fixed;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    width: 100%;
    top: 0;
    z-index: 999;
}

.red {
    color: red;
}

.my-link {
    color: #000000 !important;
}

.my-link:hover {
    color: #6655ee !important;
}

.btn-login {
    color: #000000;
    border: 1px solid #000000;
}

.btn-login:hover {
    color: #6655ee !important;
    border: 1px solid #6655ee;
}

.search-dropdown {
    position: absolute;
    top: 36px;
    width: 100%;
    max-height: 400px;
    z-index: 9;
    color: #a6a3a3;
    background-color: #fff;
    font-size: 14px;
    overflow-y: auto;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
}

.view-all {
    background: #ddd;
    color: #000;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
}

.head-type {
    color: #000;
    padding: 10px 20px;
    background: #CCC;
}

.search-dropdown ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 100%;
}

.search-dropdown ul li {
    padding: 10px;
}


/* .items ul li :hover {
    background-color: aqua;
} */

.search-dropdown ul li a {
    color: #a6a3a3;
    text-decoration: none;
}

.search-spinner {
    position: absolute;
    right: 6px;
    bottom: 12px;
    width: 20px;
    height: 20px;
}

.notifications-dropdown {
    width: 290px;
    top: 120% !important;
}

.t-122 {
    top: 122% !important;
}

.notification-link {
    color: #6e5eff;
    text-decoration: none;
    font-size: 12px;
}

.notification-counter {
    position: absolute;
    background-color: red;
    color: white;
    padding: 0;
    border-radius: 50%;
    font-size: 11px;
    width: 15px;
    height: 15px;
    text-align: center;
    /*WC 06212022*/
    /*top: 12px;
    right: 6px;*/
    top: 6px;
    right: 3px;
    /*WC 06212022*/
}

.notification-pic {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
}

.notification-text {
    overflow: hidden;
    width: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.icon :hover {
    fill: #6655ee;
    color: #6655ee !important;
}

.dropdown-item svg {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.cross-icon {
    position: absolute;
    right: 8px;
    width: 15px;
}

.navbar {
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
}

.profile-image {
    width: 40px;
    height: 40px;
    text-align: center;
    color: #fff;
    background: #6655ee;
    border-radius: 4px;
    /*display: inline-block;*/
    font-size: 16px;
    font-weight: 600;
    vertical-align: middle;
    text-transform: uppercase;
    line-height: 40px;
}

@media(max-width: 991px) {
    .hbfilms-top-header .navbar-nav-2>li {
        margin: 10px 0px;
    }
    .hbfilms-top-header .navbar-nav-2 {
        margin-top: 10px;
    }
    .notification-counter {
        margin: 0 auto;
        top: 7px;
        right: 0;
        left: 15px;
    }
    /* .hbfilms-top-header .navbar-nav-2 .notif-drop .dropdown-menu {
        width: 387px;
    } */
    .navbar-nav-2 {
        width: 100%;
    }
    .notifications-dropdown {
        width: 290px !important;
    }
}


/* Tooltip */

.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptexts {
    visibility: visible;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: -5px;
    left: 110%;
}

.tooltip .tooltiptexts::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
}

.tooltip:hover .tooltiptexts {
    visibility: visible;
}

.help-box {
    position: absolute;
    left: 552px;
    background: #5721bf!important;
    border-radius: 5px;
    padding: 17px;
    top: 5px;
    width: 244px;
    border: 2px solid #da6c31;
    color: white;
}

.help-box::after {
    content: "";
    position: absolute;
    top: 5%;
    right: 100%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
}

.fa-times-circle {
    position: absolute;
    right: 10px
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/header/header.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,8CAA8C;IAC9C,WAAW;IACX,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA;;GAEG;;AAEH;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd;gBACY;IACZ,QAAQ;IACR,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,QAAQ;QACR,QAAQ;QACR,UAAU;IACd;IACA;;OAEG;IACH;QACI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA,YAAY;;AAEZ;IACI,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB;AACJ","sourcesContent":[".hbfilms-top-header {\r\n    position: fixed;\r\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\r\n    width: 100%;\r\n    top: 0;\r\n    z-index: 999;\r\n}\r\n\r\n.red {\r\n    color: red;\r\n}\r\n\r\n.my-link {\r\n    color: #000000 !important;\r\n}\r\n\r\n.my-link:hover {\r\n    color: #6655ee !important;\r\n}\r\n\r\n.btn-login {\r\n    color: #000000;\r\n    border: 1px solid #000000;\r\n}\r\n\r\n.btn-login:hover {\r\n    color: #6655ee !important;\r\n    border: 1px solid #6655ee;\r\n}\r\n\r\n.search-dropdown {\r\n    position: absolute;\r\n    top: 36px;\r\n    width: 100%;\r\n    max-height: 400px;\r\n    z-index: 9;\r\n    color: #a6a3a3;\r\n    background-color: #fff;\r\n    font-size: 14px;\r\n    overflow-y: auto;\r\n    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.view-all {\r\n    background: #ddd;\r\n    color: #000;\r\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.head-type {\r\n    color: #000;\r\n    padding: 10px 20px;\r\n    background: #CCC;\r\n}\r\n\r\n.search-dropdown ul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n}\r\n\r\n.search-dropdown ul li {\r\n    padding: 10px;\r\n}\r\n\r\n\r\n/* .items ul li :hover {\r\n    background-color: aqua;\r\n} */\r\n\r\n.search-dropdown ul li a {\r\n    color: #a6a3a3;\r\n    text-decoration: none;\r\n}\r\n\r\n.search-spinner {\r\n    position: absolute;\r\n    right: 6px;\r\n    bottom: 12px;\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n.notifications-dropdown {\r\n    width: 290px;\r\n    top: 120% !important;\r\n}\r\n\r\n.t-122 {\r\n    top: 122% !important;\r\n}\r\n\r\n.notification-link {\r\n    color: #6e5eff;\r\n    text-decoration: none;\r\n    font-size: 12px;\r\n}\r\n\r\n.notification-counter {\r\n    position: absolute;\r\n    background-color: red;\r\n    color: white;\r\n    padding: 0;\r\n    border-radius: 50%;\r\n    font-size: 11px;\r\n    width: 15px;\r\n    height: 15px;\r\n    text-align: center;\r\n    /*WC 06212022*/\r\n    /*top: 12px;\r\n    right: 6px;*/\r\n    top: 6px;\r\n    right: 3px;\r\n    /*WC 06212022*/\r\n}\r\n\r\n.notification-pic {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n}\r\n\r\n.notification-text {\r\n    overflow: hidden;\r\n    width: inherit;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.icon :hover {\r\n    fill: #6655ee;\r\n    color: #6655ee !important;\r\n}\r\n\r\n.dropdown-item svg {\r\n    width: 18px;\r\n    height: 18px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.cross-icon {\r\n    position: absolute;\r\n    right: 8px;\r\n    width: 15px;\r\n}\r\n\r\n.navbar {\r\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.profile-image {\r\n    width: 40px;\r\n    height: 40px;\r\n    text-align: center;\r\n    color: #fff;\r\n    background: #6655ee;\r\n    border-radius: 4px;\r\n    /*display: inline-block;*/\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    vertical-align: middle;\r\n    text-transform: uppercase;\r\n    line-height: 40px;\r\n}\r\n\r\n@media(max-width: 991px) {\r\n    .hbfilms-top-header .navbar-nav-2>li {\r\n        margin: 10px 0px;\r\n    }\r\n    .hbfilms-top-header .navbar-nav-2 {\r\n        margin-top: 10px;\r\n    }\r\n    .notification-counter {\r\n        margin: 0 auto;\r\n        top: 7px;\r\n        right: 0;\r\n        left: 15px;\r\n    }\r\n    /* .hbfilms-top-header .navbar-nav-2 .notif-drop .dropdown-menu {\r\n        width: 387px;\r\n    } */\r\n    .navbar-nav-2 {\r\n        width: 100%;\r\n    }\r\n    .notifications-dropdown {\r\n        width: 290px !important;\r\n    }\r\n}\r\n\r\n\r\n/* Tooltip */\r\n\r\n.tooltip {\r\n    position: relative;\r\n    display: inline-block;\r\n    border-bottom: 1px dotted black;\r\n}\r\n\r\n.tooltip .tooltiptexts {\r\n    visibility: visible;\r\n    width: 120px;\r\n    background-color: black;\r\n    color: #fff;\r\n    text-align: center;\r\n    border-radius: 6px;\r\n    padding: 5px 0;\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: -5px;\r\n    left: 110%;\r\n}\r\n\r\n.tooltip .tooltiptexts::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 100%;\r\n    margin-top: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: transparent black transparent transparent;\r\n}\r\n\r\n.tooltip:hover .tooltiptexts {\r\n    visibility: visible;\r\n}\r\n\r\n.help-box {\r\n    position: absolute;\r\n    left: 552px;\r\n    background: #5721bf!important;\r\n    border-radius: 5px;\r\n    padding: 17px;\r\n    top: 5px;\r\n    width: 244px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n}\r\n\r\n.help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 5%;\r\n    right: 100%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n}\r\n\r\n.fa-times-circle {\r\n    position: absolute;\r\n    right: 10px\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
